import { ActionType, ComponentType } from '../../enums';

export interface CreateSearchErrorEventPayloadOptions {
  errors: {
    code?: number;
    message: string;
    name: string;
  }[];
  pageType: string;
  searchTerm: string;
  url: string;
}

export interface CreateSearchErrorEventPayloadReturn {
  event_data: {
    action: ActionType;
    component_type: ComponentType;
    errors: {
      code?: number;
      message: string;
      name: string;
    }[];
    page_type: string;
    search_term: string;
    url: string;
  };
}

export const createSearchErrorEventPayload = ({
  errors,
  searchTerm,
  url,
  pageType,
}: CreateSearchErrorEventPayloadOptions): CreateSearchErrorEventPayloadReturn => {
  return {
    event_data: {
      action: ActionType.ERROR,
      component_type: ComponentType.SEARCH,
      errors: errors.map((error) => ({
        code: error.code,
        message: error.message,
        name: error.name,
      })),
      search_term: searchTerm,
      url,
      page_type: pageType,
    },
  };
};
